import { cn } from '../../lib/utils';

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  logo?: React.ReactNode;
  navigation?: React.ReactNode;
  actions?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = function ({
  className,
  logo,
  navigation,
  actions,
  ...props
}) {
  return (
    /*
     * `header`, not `div`. This is the site banner on every marketing page,
     * and rendering it as a div left the page with no banner landmark at all —
     * a screen-reader user could not jump to it, and the "skip to content"
     * link in the layout has nothing meaningful to skip past.
     */
    <header
      className={cn(
        'site-header bg-background/80 dark:bg-background/80 sticky top-0 z-10 w-full backdrop-blur-lg',
        className,
      )}
      {...props}
    >
      <div className="container">
        <div className="flex h-14 items-center gap-x-4">
          <div className="shrink-0">{logo}</div>

          <div className="order-first flex min-w-0 flex-1 justify-start md:order-none md:justify-center">
            {navigation}
          </div>

          <div className="relative z-10 ml-auto flex shrink-0 items-center justify-end gap-x-2">
            {actions}
          </div>
        </div>
      </div>
    </header>
  );
};
